import React__default from 'react';

const sanitizeRowProps = (row, rowExpansionRenderer) => {
  var _row$subRows;

  const props = {
    index: row.index,
    indexPath: row.id,
    values: row.original
  };

  if (((_row$subRows = row.subRows) === null || _row$subRows === void 0 ? void 0 : _row$subRows.length) > 0) {
    props.isExpanded = !!row.isExpanded;
    props.depth = row.depth;

    props.toggleRowExpanded = () => row.toggleRowExpanded(!props.isExpanded);
  } else if (rowExpansionRenderer) {
    props.isExpanded = !!row.isExpanded;

    props.toggleRowExpanded = () => row.toggleRowExpanded(!props.isExpanded);
  }

  if (row.toggleRowEditing) {
    props.isEditing = !!row.isEditing;
    props.toggleRowEditing = row.toggleRowEditing;
  }

  return props;
};
const getColumnsFromChildren = (children, rowExpansionRenderer) => {
  const sortRules = [];
  const columns = React__default.Children.toArray(children).filter(child => !!child && !child.props.hidden) // skip falsey or hidden columns
  .map(({
    props: {
      children: groupChildren,
      ...props
    }
  }) => {
    const column = { ...props
    };
    column.sortType = column.sortType || 'auto';
    column.disableSortBy = column.disableSorting; // this is a Table.Group - TODO: Find a better way to determine the child type

    if (props.title && groupChildren) {
      column.Header = props.title;
      const {
        columns: groupColumns,
        sortRules: groupSortRules
      } = getColumnsFromChildren(groupChildren, rowExpansionRenderer);
      column.columns = groupColumns;
      groupSortRules.forEach(sort => sortRules.push(sort));
    } else {
      column.accessor = props.accessor;
      column.Header = props.headRenderer || '';

      column.Cell = columnProps => {
        var _props$cellRenderer, _cell$value;

        const cell = {
          accessor: columnProps.cell.column.id,
          row: sanitizeRowProps(columnProps.cell.row, rowExpansionRenderer),
          value: columnProps.cell.value
        };

        if (cell.row.isEditing && typeof props.editRenderer === 'function') {
          return props.editRenderer(cell);
        }

        return typeof props.cellRenderer === 'function' ? (_props$cellRenderer = props.cellRenderer(cell)) !== null && _props$cellRenderer !== void 0 ? _props$cellRenderer : null : (_cell$value = cell.value) !== null && _cell$value !== void 0 ? _cell$value : null;
      }; // custom props


      column.align = props.align;
      column.flex = props.flex;

      if (props.sort && !props.disableSorting) {
        sortRules.push({
          id: props.accessor,
          desc: props.sort === 'desc'
        });
      }
    }

    return column;
  });
  return {
    columns,
    sortRules
  };
};
const getInternalSortRules = sortRules => {
  return sortRules === null || sortRules === void 0 ? void 0 : sortRules.map(rule => ({
    id: rule.accessor,
    desc: rule.desc
  }));
};

export { getColumnsFromChildren, getInternalSortRules, sanitizeRowProps };
//# sourceMappingURL=util.js.map
